/**
 * 模組頁面代碼 : 1310-UI-02
 * 頁面說明 : 大樓資料新增修改視窗
 * @module web/modules/building/components/BuildingModal
 */

// ----- import from npm modules -----
import React, { useState, useEffect, useRef } from 'react';

// ----- import from local modules -----

// ----- constants -----
const BUILDING_NEW = 'new';
const BUILDING_EDIT = 'edit';

const RESPONSE_OK = 200;
const TITLE_BUILDING_NEW = '新增大樓資料';
const TITLE_BUILDING_EDIT = '修改大樓資料';

const BuildingModal = React.forwardRef((props, ref) => {
    const { mode, building, searchBuilding } = props;
    const inputRadiusRef = useRef(null);

    let modalIcon = mode === BUILDING_NEW? '#ico-plus' : '#ico-edit';
    let modalTitleText = mode === BUILDING_NEW? TITLE_BUILDING_NEW : TITLE_BUILDING_EDIT;

    // 初始化state
    const [formValues, setFormValues] = useState({
        modalBuildingName: '',
        modalBuildingEleCount: '',
        modalBuildingFloorCount: '',
        modalBuildingBasementCount: '',
        modalBuildingLatitude: '',
        modalBuildingLongitude: '',
        modalBuildingCtlRadiusUnset: false,
        modalBuildingCtlRadius: '',
    });

    const [validationMessage, setValidationMessage] = useState('');
    const [WarningMessage, setWarningMessage] = useState('');
    const [invalidShow, setInvalidShow] = useState('none');
    const isInvalidLatitude = !/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/.test(formValues.modalBuildingLatitude);
    const isInvalidLongitude = !/^[-+]?((1[0-7]\d|180)(\.\d+)?|([1-9]?\d(\.\d+)?))$/.test(formValues.modalBuildingLongitude);
    
    // Handle change event
    const handleChange = (event) => {
        const target = event.target;
        let value = target.value;
        let validMsg = '';
        let warnMsg = '';

        if (target.name === 'modalBuildingCtlRadiusUnset') {
            const modalBuildingCtlRadiusField = document.getElementById('modalBuildingCtlRadius');
            if (modalBuildingCtlRadiusField) {
                modalBuildingCtlRadiusField.disabled = target.checked; // Enable the field
            }
        }
        if (target.name === 'modalBuildingCtlRadius') {
            const inputRadius = inputRadiusRef.current;
            if (parseFloat(value) <= 0) {
                validMsg = '設定值不得為0';
            }
            if (parseFloat(value) > 0 && parseFloat(value) <= 10) {
                warnMsg = '設定過於嚴格';
                setWarningMessage(warnMsg);
            } else if (parseFloat(value) > 10 && parseFloat(value) <= 99999) {
                setWarningMessage('');
            }

            const isInputRadiusValid = validMsg === '';
            inputRadius.classList.toggle('is-valid', isInputRadiusValid && inputRadius.checkValidity());
            inputRadius.classList.toggle('is-invalid', !isInputRadiusValid);
            if (!isInputRadiusValid) {
                inputRadius.setCustomValidity('設定半徑值不得為0，且請大於10公尺。');
                setValidationMessage(validMsg);
                setWarningMessage('')
            } else {
                inputRadius.setCustomValidity('')
            }
        }

        setFormValues({
            ...formValues,
            [target.name]: target.type === 'checkbox' ? target.checked : value,
        });
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        const patterns = {
            modalBuildingLatitude: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
            modalBuildingLongitude: /^[-+]?((1[0-7]\d|180)(\.\d+)?|([1-9]?\d(\.\d+)?))$/,
        };
    };
    
    // 使用useEffect在building改變才更新formValues
    useEffect(() => {
        setFormValues({
            modalBuildingName: building? building.buildingName : '',
            modalBuildingEleCount: building? building.elevatorNumbers : '',
            modalBuildingFloorCount: building? building.aboveFloors : '',
            modalBuildingBasementCount: building? building.underFloors : '',
            modalBuildingLatitude: building? building.latitude : '',
            modalBuildingLongitude: building? building.longitude : '',
            modalBuildingCtlRadiusUnset: building? building.flgUnlimit === 1 : false,
            modalBuildingCtlRadius: building && building.controlRadius !== null ? building.controlRadius : '',
        });
        setValidationMessage('');
        setInvalidShow('none');
    }, [building]);

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;

        // 檢查表單是否驗證通過
        if (form.checkValidity() === false) {
            setInvalidShow('block');
            form.classList.add('was-validated');
            return;
        }

        // 建立 FormData 讀取表单的值
        const formData = new FormData(form);

        // 建立 building 物件
        const controlRadiusUnset = formData.get('modalBuildingCtlRadiusUnset');
        if (controlRadiusUnset) {
            formData.set('modalBuildingCtlRadius', null);
        }
        const saveBuilding = {
            buildingId: mode === BUILDING_NEW? null : building.buildingId,
            buildingName: formData.get('modalBuildingName'),
            elevatorNumbers: parseInt(formData.get('modalBuildingEleCount')),
            aboveFloors: parseInt(formData.getAll('modalBuildingFloorCount')),
            underFloors: parseInt(formData.get('modalBuildingBasementCount')),
            latitude: parseFloat(formData.get('modalBuildingLatitude')),
            longitude: parseFloat(formData.get('modalBuildingLongitude')),
            flgUnlimit: formData.get('modalBuildingCtlRadiusUnset')? 1 : 0,
            controlRadius: formData.get('modalBuildingCtlRadius') !== null? parseFloat(formData.get('modalBuildingCtlRadius')) : null,
        };

        // 呼叫父層元件的新增或修改大樓資料函式
        if (mode === BUILDING_NEW) {
            // 调用 props.addBuilding 方法
            props.addBuilding(saveBuilding).then((response) => {
                const statusCode = response.payload.code;
                if (statusCode !== RESPONSE_OK) {
                    $(ref.current).modal('hide');
                    props.onErrorHandle(TITLE_BUILDING_NEW, response.payload );
                } else {
                    // 调用 fetchBuildingList and Hide the modal
                    const { buildingId } = searchBuilding;
                    props.fetchBuildingSelection();
                    props.fetchBuildingList(buildingId).then(() => {
                        props.setNeedBuildingLoad(true);
                        $(ref.current).modal('hide');
                    });
                }
            });
        } else if (mode === BUILDING_EDIT) {
            // 调用 props.editBuilding 方法
            props.editBuilding(saveBuilding).then((response) => {
                const statusCode = response.payload.code;
                if (statusCode !== RESPONSE_OK) {
                    $(ref.current).modal('hide');
                    props.onErrorHandle(TITLE_BUILDING_EDIT, response.payload );
                } else {
                    // 调用 fetchBuildingList and Hide the modal
                    const { buildingId } = searchBuilding;
                    props.fetchBuildingSelection();
                    props.fetchBuildingList(buildingId).then(() => {
                        props.setNeedBuildingLoad(true);
                        $(ref.current).modal('hide');
                    });
                }
            });
        }
    };

    return (
        <div ref={ref}
            className="modal fade"
            id="modalBuilding"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="modalBuildingLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <form className="modal__form modal-content needs-validation" id="modalBuildingForm" onSubmit={handleSubmit}>
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="modalBuildingLabel">
                            <div className="modal__title__badge">
                                <svg className="badge__icon" aria-hidden="true">
                                    <use href={modalIcon}></use>
                                </svg>
                            </div>
                            <div className="modal__title__text">{modalTitleText}</div>
                        </h1>
                        <button type="button" className="btn-close btn-cancel" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex flex-column gap-3 px-2">
                            <div className="modal__form__catagory row">
                                <div className="col-3">
                                    <div className="modal__form__catagory__lable">大樓基本資料</div>
                                </div>
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col-6">
                                            <label htmlFor="modalBuildingName" className="form-label">大樓名稱*</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="modalBuildingName"
                                                name="modalBuildingName"
                                                value={formValues.modalBuildingName}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label htmlFor="modalBuildingEleCount" className="form-label">電梯數量*</label>
                                            <input
                                                type="number"
                                                min="1"
                                                max="99999"
                                                className="form-control form-control-sm"
                                                id="modalBuildingEleCount"
                                                name="modalBuildingEleCount"
                                                value={formValues.modalBuildingEleCount}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <label htmlFor="modalBuildingFloorCount" className="form-label">地面樓層數*</label>
                                            <input
                                                type="number"
                                                min="1"
                                                className="form-control form-control-sm"
                                                id="modalBuildingFloorCount"
                                                name="modalBuildingFloorCount"
                                                value={formValues.modalBuildingFloorCount}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label htmlFor="modalBuildingBasementCount" className="form-label">地下樓層數*</label>
                                            <input
                                                type="number"
                                                min="0"
                                                className="form-control form-control-sm"
                                                id="modalBuildingBasementCount"
                                                name="modalBuildingBasementCount"
                                                value={formValues.modalBuildingBasementCount}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <label htmlFor="modalBuildingFloorCount" className="form-label"><span style={{ color: 'red' }}>修改地面或地下樓層數將會重置電梯樓層設定及刪除原關連的梯控申請資料</span></label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal__form__catagory row">
                                <div className="col-3">
                                    <div className="modal__form__catagory__lable">大樓位置</div>
                                </div>
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col-6">
                                            <label htmlFor="modalBuildingLatitude" className="form-label">緯度*</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${isInvalidLatitude ? 'is-invalid' : ''}`}
                                                id="modalBuildingLatitude"
                                                name="modalBuildingLatitude"
                                                pattern="^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$"
                                                value={formValues.modalBuildingLatitude}
                                                onChange={handleChange}
                                                onBlure={handleBlur}
                                                required
                                            />
                                            <div className="invalid-feedback">請輸入正確格式</div>
                                        </div>
                                        <div className="col-6">
                                            <label htmlFor="modalBuildingLongitude" className="form-label">經度*</label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${isInvalidLongitude ? 'is-invalid' : ''}`}
                                                id="modalBuildingLongitude"
                                                name="modalBuildingLongitude"
                                                pattern="^[-+]?((1[0-7]\d(\.\d+)?|180(\.0+)?)|([1-9]?\d(\.\d+)?))$"
                                                value={formValues.modalBuildingLongitude}
                                                onChange={handleChange}
                                                onBlure={handleBlur}
                                                required
                                            />
                                            <div className="invalid-feedback">請輸入正確格式</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal__form__catagory row">
                                <div className="col-3">
                                    <div className="modal__form__catagory__lable">控制半徑</div>
                                </div>
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col-12">
                                            <label htmlFor="modalBuildingCtlRadius" className="form-label">控制半徑 <span style={{ color: 'red' }}>(設定半徑值不得為0，且請大於10公尺。)</span></label>
                                            <div className="input-group input-group-sm">
                                                <div className="input-group-text">
                                                    <input
                                                        className="form-check-input mt-0"
                                                        id="modalBuildingCtlRadiusUnset"
                                                        name="modalBuildingCtlRadiusUnset"
                                                        type="checkbox"
                                                        value={formValues.modalBuildingCtlRadiusUnset}
                                                        checked={formValues.modalBuildingCtlRadiusUnset}
                                                        onChange={handleChange}
                                                        aria-label="不限制"
                                                    />
                                                    <label htmlFor="modalBuildingCtlRadiusUnset" className="form-label ms-2 mt-1">不限制</label>
                                                </div>
                                                <input
                                                    type="number"
                                                    ref={inputRadiusRef}
                                                    min="1"
                                                    max="99999"
                                                    className="form-control text-center"
                                                    id="modalBuildingCtlRadius"
                                                    name="modalBuildingCtlRadius"
                                                    value={formValues.modalBuildingCtlRadius}
                                                    onChange={handleChange}
                                                    aria-label="Text input with checkbox"
                                                />
                                                <div className="input-group-text ts-7">m</div>
                                                {validationMessage && <div className="invalid-feedback">{validationMessage}</div>}
                                            </div>
                                            {WarningMessage && <div className="warn-feedback">{WarningMessage}</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-warning global-invalid-feedback" style={{ display: invalidShow }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">取消</button>
                        <button type="submit" className="btn btn-primary">儲存</button>
                    </div>
                </form>
            </div>
        </div>
    );
});

export default BuildingModal;